import { SelectedCoworkingType } from './SelectedCoworkingType';

export enum WorkplaceInCoworkingType {
  FlexibleWorkplace = SelectedCoworkingType.FlexibleWorkplace,
  FixedWorkplace = SelectedCoworkingType.FixedWorkplace,
}
